import './pie_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.GenderPieChartView extends Monitoring.Views.Charts.PieChartView

  customChartOptions: ->
    return {
      colors: ['#FF99CC', '#66CCFF', '#F3F781', '#9E9E9E']
    }

  initialize: (@options = {}) ->
    @title = I18n.t('monitoring.dashboard.charts.gender')
    @title_en = I18n.t('monitoring.dashboard.charts.gender', {'locale': 'en'})
    super(@options)

  getNewQuery: (event) ->
    name = event.point.code || event.point.name
    query = @searchQuery.deepCopy()
    query.set('enhanced_gender', [ name ])
    return query

  afterAppend: ->
    @$el.find('.chart').html('')
    if @_settings.maximized
      @$el.addClass('w2 h2')
    else
      if @dataBenchmark
        @$el.addClass('w2')

    @url = "/monitoring/api/charts/unique_user_gender_count"
    @ajaxCall(@url, @getSearchQuery().toJSON(), (response) =>

      @pieData = response
      if @pieData[0]? && @pieData[0][0]?
        @pieData = _.sortBy( @pieData, (facet) -> (facet[0] || '').toLowerCase() )
        @pieData = _.map(@pieData, (facet) => {term: facet[0], count: facet[1], visible: @getVisibilityFor(facet[0])})
      else
        @pieData = _.sortBy( @pieData, (facet) -> (facet["term"] || '').toLowerCase() )

      setTimeout => # to avoid the harmless "Uncaught TypeError: a.onContainerClick is not a function"
        @benchmarkChart = new Highcharts.Chart(@benchmarkChartOptions(@current)) if @dataBenchmark
        @chart = new Highcharts.Chart($.extend(true, @_getOptions(), @_getChartOptions()))
        @trigger('masonry')
        @$el.removeClass('processing')
      , 20
    )

  _getOptions: ->
    if @pieData[0]? && @pieData[0][0]?
      @pieData = _.sortBy( @pieData, (facet) -> (facet[0] || '').toLowerCase() )
      @pieData = _.map(@pieData, (facet) => {term: facet[0], count: facet[1], visible: @getVisibilityFor(facet[0])})
    else
      @pieData = _.sortBy( @pieData, (facet) -> (facet["term"] || '').toLowerCase() )

    pieData = @getPieData()

    pieOptions = new Customer.Reports.PieOptions(
      container: @$el.find('.chart')[0]
      data: pieData
      onClick: @_previewSearch unless @_settings.avoid_preview
      legendItemClick: @legendItemClickEvent
      onToggleMaximize: => @toggleMaximize()
      isMaximized: @_settings.maximized
    ).get()

  getPieData: ->
    return [
      ['female', @getCount('female')],
      ['male', @getCount('male')],
      ['no gender', @getCount('no gender')],
      ['unknown', @getCount('unknown')],
    ]

  getCount: (term_name) ->
    facet = _.find(@pieData, (facet) ->
      facet.term == term_name
    )
    return if facet then facet.count else 0

  getSearchQuery: ->
    query = @searchQuery.deepCopy()
    query

  benchmarkChartOptions: (currentBenchmark) ->
    series = @_getOptions().series

    benchmark_series = $.extend({}, series[0])
    benchmark_series.data = $.extend([], @_benchmarkDataFromResponse())

    indexOfMissing = _.findIndex(benchmark_series.data, {code: 'missing'})
    if indexOfMissing > -1
      benchmark_series.data[indexOfMissing].code = 'no gender'
      benchmark_series.data[indexOfMissing].name = 'no gender'

    sorted_benchmark_data = []
    for group in series[0].data
      indexOfGroup = _.findIndex(benchmark_series.data, {code: group.name})
      if indexOfGroup > -1
        benchmark_series.data[indexOfGroup].name = benchmark_series.data[indexOfGroup].code
        sorted_benchmark_data.push(benchmark_series.data[indexOfGroup])
      else
        sorted_benchmark_data.push({code: group.name, y: 0})
    benchmark_series.data = sorted_benchmark_data
    options = $.extend(true, @_getOptions(), @_getChartOptions())
    options.title = {text: currentBenchmark, y: 30, align: 'left', x:10, floating: true}
    options.title.style = {fontSize: '13px', fontWeight: 'bold'}
    options.series = [benchmark_series]
    options.chart.renderTo = @$el.find('.benchmark-chart')[0]
    return options
